import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AssetsFormConfig from 'containers/assets/AssetsFormConfig';
import AssetsFormHandlers from 'containers/assets/AssetsFormHandlers';
import { trimDmsReference } from 'lib/assets/dms_reference';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

import { getCompany, getSubcompany } from 'auth/selectors';
import { getAsset } from 'selectors/assets';

import Assets from 'components/assets';

import { newAsset, addAsset, resetAssetsForm } from 'containers/assets/actions';
import { addGrowlMessage as addMsg, clearGrowlMessages as clrMsg } from 'messages/actions';

class AssetsAddContainer extends PureComponent {
  static propTypes = {
    addAsset: PropTypes.func.isRequired,
    newAsset: PropTypes.func.isRequired,
    clrMsg: PropTypes.func.isRequired,
    addMsg: PropTypes.func.isRequired,
  };

  componentWillMount = () => {
    this.props.newAsset();
  };

  componentWillUnmount = () => this.props.resetAssetsForm();

  handleSubmit = (e) => {
    const { company, history, subcompany, asset, addMsg, addAsset } = this.props;

    const cId = company.id;
    const sId = subcompany.id;

    addAsset(cId, sId, trimDmsReference(asset))
      .then(({ value }) => {
        addMsg(value.message, 'success', 'common.success');
        history.push(`/companies/${cId}/subcompanies/${sId}/assets`);
      })
      .catch((e) => {
        addMsg(e.message, 'error', 'common.error');
      });
  };

  uploadFiles;

  render = () => (
    <AssetsFormConfig
      render={({
        accounts,
        catalogs,
        costCenters,
        employees,
        isLoading,
        locations,
        projects,
        providers,
        subaccounts,
        sublocations,
        depreciations,
        asset_levels,
      }) => (
        <AssetsFormHandlers
          render={({
            beforeSubmit,
            uploadFiles,
            files,
            handleValidation,
            handleValueChange,
            handleFileAdd,
            handleGroupChange, //Groups
            handleCustomFieldChange, //Groups
            handleFileRemove,
            isSubmitted,
            isSaving,
          }) => (
            <Assets.AddView
              accounts={accounts}
              asset={this.props.asset}
              catalogs={catalogs}
              company={this.props.company}
              costCenters={costCenters}
              depreciations={depreciations}
              employees={employees}
              files={files}
              handleFileAdd={handleFileAdd}
              handleFileRemove={handleFileAdd}
              handleSubmit={beforeSubmit(uploadFiles(this.handleSubmit))}
              handleValidation={handleValidation}
              handleValueChange={handleValueChange}
              isLoading={isLoading}
              handleGroupChange={handleGroupChange} //Groups
              handleCustomFieldChange={handleCustomFieldChange} //Groups
              groups={this.props.groups} //Groups
              isSaving={isSaving}
              isSubmitted={isSubmitted}
              locations={locations}
              projects={projects}
              providers={providers}
              subaccounts={subaccounts}
              subcompany={this.props.subcompany}
              sublocations={sublocations}
              asset_levels={asset_levels}
            />
          )}
        />
      )}
    />
  );
}

const mapDispatchToProps = {
  addAsset,
  addMsg,
  clrMsg,
  newAsset,
  resetAssetsForm,
};

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  asset: getAsset(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetsAddContainer));



// WEBPACK FOOTER //
// src/containers/assets/AssetsAddContainer.js